import {
	Box,
	Container,
	Divider,
	makeStyles,
	Typography,
	LinearProgress
} from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useActions, useValues } from 'kea';
import Fuse from 'fuse.js';

import vehiclelogic from 'src/store/vehicle';
import profilelogic from 'src/store/profile';
import keylogic from 'src/store/key';

import Page from 'src/components/Page';
import checkRole from '../../utils/checkRole';
import Result from './Results';
import Toolbar from './Toolbar';
import RenameKeyDialog from './RenameKeyDialog'
//TODO clean styles
const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: theme.palette.background.dark,
		minHeight: '100%',
		paddingBottom: theme.spacing(3),
		paddingTop: theme.spacing(3)
	},
	card: {

	}
}));


let columns = [
	{
		field: 'image',
		headerName: 'Icon',
		align: 'left',
		width: 50,
	},
	{
		field: 'reginfo',
		headerName: 'Registration',
		align: 'left',
		width: 200,
	},
	{
		field: 'name',
		headerName: 'Name',
		align: 'left',
		width: 200,
	},
	{
		field: 'info',
		headerName: 'Information',
		align: 'left',
		width: 250,
	},
	{
		field: 'keys',
		headerName: 'Keys',
		align: 'left',
		width: 120,
	},
	{
		field: 'geofences',
		headerName: 'Geofences',
		align: 'left',
		width: 70,
	},
	{
		field: 'alerts',
		headerName: 'Alerts',
		align: 'left',
		width: 70,
	},
	{
		field: 'groups',
		headerName: 'Groups',
		align: 'left',
		width: 70,
	},
	{
		field: 'actions',
		align: 'left',
		headerName: 'Actions',
		width: 150,
	},
];




const MobileVehiclesViewFunc = () => {

	const classes = useStyles();

	const { profile } = useValues(profilelogic);

	const { vehicles } = useValues(vehiclelogic);
	const { fetchAll: vehicleFetchAll } = useActions(vehiclelogic);

	const { keys } = useValues(keylogic);
	const { fetchAll: keyFetchAll } = useActions(keylogic);

	const [filtered, setFiltered] = useState(vehicles);

	const [search, setSearch] = useState('');

	useEffect(() => {
		vehicles ?? vehicleFetchAll();
		if (checkRole(profile, ['KeyView', 'KeyEdit'])) {
			keys ?? keyFetchAll();
		}
	}, []) // eslint-disable-line

	useEffect(() => {
		if (search === '') {
			setFiltered(vehicles);
		} else {
			let found = fuse.search(search);
			found = found.map(item => {
				item.item.refIndex = item.refIndex;
				return item.item;
			});
			setFiltered(found);
		}
	}, [vehicles, search])// eslint-disable-line


	if (!checkRole(profile, ['VehicleEdit'])) {
		columns = columns.filter((item) => {
			return item.field !== 'actions';
		});
	}

	if (!checkRole(profile, ['GeofenceView', 'GeofenceEdit'])) {
		columns = columns.filter((item) => {
			return item.field !== 'geofences';
		});
	}

	if (!checkRole(profile, ['AlertView', 'AlertEdit'])) {
		columns = columns.filter((item) => {
			return item.field !== 'alerts';
		});
	}

	if (!checkRole(profile, ['KeyView', 'KeyEdit'])) {
		columns = columns.filter((item) => {
			return item.field !== 'keys';
		});
	}

	if (vehicles === null) {
		return <LinearProgress />
	}

	const fuse = new Fuse(vehicles, {
		keys: ['tags', 'type', 'name', 'odometer', 'registration_number', 'registration_state', 'company', 'model', 'year', 'color', 'keys.name', 'keys.id']
	});

	const handle_search = (e) => setSearch(e.target.value);



	return (
		<Page
			className={classes.root}
			title="Vehicles"
		>
			<Container maxWidth={false}>
				<Box mt={3} >
					<Typography variant="h3" gutterBottom>
						Vehicles
					</Typography>
					<Divider />
				</Box>
				<Box display="flex" flexDirection="row">
					<Toolbar on_search={handle_search} />
					<Box ml="auto" style={{ paddingTop: "15px" }}>
						{checkRole(profile, ['KeyEdit']) && <RenameKeyDialog />}
					</Box>
				</Box>
				<Box mt={3}>
					<Result rows={filtered} columns={columns} />
				</Box>
			</Container>
		</Page>
	);
};

export default MobileVehiclesViewFunc;
